import {
  sessionStart,
  setTokens,
  postAuthTokenSuccess,
  fetchUser,
} from '@rsos/sinatra';
import { configureUserScope } from '@rsos/utils/sentry';
import packageJson from '../../package.json';
import handleRedirect from '../utils/handleRedirect';
import { setUserInfo } from './auth';

export const irpLogin = tokens => dispatch => {
  dispatch(sessionStart());
  setTokens(tokens);
  dispatch(postAuthTokenSuccess(tokens));

  return dispatch(fetchUser())
    .then(res => {
      dispatch(setUserInfo(res));
      configureUserScope({
        email: res.profile.email,
        version: packageJson.version,
      });
      dispatch(handleRedirect);
    })
    .catch(err => {
      throw err;
    });
};
